import { render, staticRenderFns } from "./ProfileSurggestedDistributors.vue?vue&type=template&id=06642120"
import script from "./ProfileSurggestedDistributors.vue?vue&type=script&lang=js"
export * from "./ProfileSurggestedDistributors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports